<template>
    <div style="background-color: white">
        <v-dialog width="700px" persistent scrollable style="max-width: 500px" light v-model="stats" class="cardUp">
            <v-layout align-center column justify-center class="cardStats" style="height:100%">
                <table v-if="configOK" style="width: 100%" class="mb-3">
                    <tr>
                        <td width="70%" class="cardStatsHeader  pa-1" colspan=3>
                            <strong> STATISTICHE CHECKPOINT</strong><span style="float:right">Num partiti:
                                {{ numRilevati }} - Num ritirati: {{ numeroTotaleRitirati  }} </span>
                        </td>
                    </tr>
                    <tr>
                        <td width="10%" class=""> </td>
                        <td width="10%" align="center" class="cardStatsHeader">TRANSITATI </td>
                        <td width="10%" align="center" class="cardStatsHeader">MANCANTI</td>
                    </tr>
                    <tr v-for="cp in checkpoints " :key="'titolo' + cp.idAri">
                        <td width="10%" class="frazioniTitle frazioniValueR mr-2" align="right">{{ cp.nome }} </td>
                        <td width="10%" class="frazioniValue">{{ mappaIntermedi['CK' + cp.idAri]}} </td>
                        <td width="10%" class="frazioniValue">{{ getNumMancanti('CK'+cp.idAri )}} </td>
                    </tr>
                </table>
                <v-btn round class="black  white--text" @click="stats = false">Chiudi</v-btn>
            </v-layout>
        </v-dialog>

        <v-dialog width="500px" persistent scrollable style="max-width: 340px" light v-model="raceInfo" class="cardUp">
            <v-layout align-center column justify-center class="cardStats" style="height:100%">
                <table v-if="configOK" style="width: 100%" class="mb-3">
                    <tr>
                        <td width="70%" class="cardStatsHeader  pa-1" colspan=2>
                            <strong> INFORMAZIONI EVENTO</strong>
                        </td>
                    </tr>
                    <tr>
                        <td class="frazioniTitle frazioniValueR mr-2">Organizzazione</td>
                        <td class="frazioniValue frazioniValueL">{{ configEvento.organizzatore }} </td>
                    </tr>
                    <tr>
                        <td class="frazioniTitle frazioniValueR mr-2">Localita'</td>
                        <td class="frazioniValue frazioniValueL">{{ configEvento.localita }} </td>
                    </tr>
                    <tr>
                        <td class="frazioniTitle frazioniValueR mr-2">Regione</td>
                        <td class="frazioniValue frazioniValueL">{{ configEvento.regione }} </td>
                    </tr>
                    <tr>
                        <td class="frazioniTitle frazioniValueR mr-2">Email</td>
                        <td class="frazioniValue frazioniValueL">{{ configEvento.organizzatore_email }} </td>
                    </tr>
                    <tr>
                        <td class="frazioniTitle frazioniValueR mr-2">Telefono</td>
                        <td class="frazioniValue frazioniValueL">{{ configEvento.organizzatore_telefono }} </td>
                    </tr>
                    <tr>
                        <td class="frazioniTitle frazioniValueR mr-2">Id ICRON</td>
                        <td class="frazioniValue frazioniValueL">{{ configEvento.idGaraIcron }} </td>
                    </tr>
                    <tr>
                        <td class="frazioniTitle frazioniValueR mr-2">Id Ari</td>
                        <td class="frazioniValue frazioniValueL">{{ configEvento.idGaraAri }} </td>
                    </tr>
                    <tr>
                        <td class="frazioniTitle frazioniValueR mr-2">Mappa</td>
                        <td class="frazioniValue frazioniValueL" @click="openLink(configEvento.openrunner_link)">LINK
                        </td>
                    </tr>
                    <tr>
                        <td class="frazioniTitle frazioniValueR mr-2">Roadbook</td>
                        <td class="frazioniValue frazioniValueL" @click="openLink(configEvento.roadbook)">LINK
                        </td>
                    </tr>
                    <tr>
                        <td class="frazioniTitle frazioniValueR mr-2">Rando Live</td>
                        <td class="frazioniValue frazioniValueL" @click="randoLive()">LINK</td>
                    </tr>
                    <tr>
                        <td class="" colspan=2 style="height:20px">
                            <hr>
                        </td>
                    </tr>
                    <tr>
                        <td class="mr-2 red white--text frazioniValueR">Smart resolver</td>
                        <td class="frazioniValue frazioniValueL" @click="magicRil()">Avvia</td>
                    </tr>
                    <tr>
                        <td class="frazioniTitle frazioniValueR mr-2">Carte di viaggio</td>
                        <td class="frazioniValue frazioniValueL" @click="openCartediViaggio()">SCARICA</td>
                    </tr>
                    <tr>
                        <td class="frazioniTitle frazioniValueR mr-2">Checkpoint operatore</td>
                        <td class="frazioniValue frazioniValueL" @click="cpOperatore()">LINK</td>
                    </tr>
                </table>
                <v-btn round class="black  white--text" @click="raceInfo = false">Chiudi</v-btn>
            </v-layout>
        </v-dialog>

        <v-dialog width="500px" persistent scrollable style="max-width: 340px" light v-model="dettaglioCP"
            class="cardUp">
            <v-layout v-if="configOK" align-center column justify-center class="cardStats" style="height:100%">
                <table style="width: 100%">
                    <tr>
                        <td width="100%" class="cardStatsHeader  pa-1">
                            <strong>
                                <v-icon color="white darken-4 mr-2" small>place</v-icon> ELENCO CHECKPOINT
                            </strong>
                            <v-icon @click="dettaglioCP = false" class="ma-0 pa-0 white--text"
                                style="float:right">close</v-icon>

                        </td>
                    </tr>
                </table>
                <v-data-table :items="checkpoints" hide-actions hide-headers class="elevation-1 mb-1"
                    style="width: 100%; border: 0px">
                    <template slot="items" slot-scope="props">
                        <tr style="height:1px">
                            <td style="height:1px" colspan="3"></td>
                        </tr>
                        <tr class="pa-2 ">
                            <td colspan="2" class="cardUp pa-1" style="">
                                <strong style=" background-color: #0D3D58; color: white;  float: left;
                                                    margin: -4px;
                                                    border-radius: 10px 0px 0px
                                                        0px;
                                                    padding: 3px;
                                                    min-width: 30px;
                                                    text-align: center;
                                                ">
                                    {{ props.index + 1 }}
                                </strong>
                                <span style="float: left">
                                    <strong class="ml-2">{{ props.item.nome }}</strong>
                                </span>
                                <span style="float: right">
                                    <strong class="mr-2">{{ props.item.codiceAPP.replaceAll("#", '-') }}</strong>
                                </span>
                                <br>
                                <span class="ml-4"> <small class="ml-2"><span class="ml-2">Km. {{ (props.item.km) }} -
                                            {{
                                                props.item.localita
                                            }} </span> </small></span>

                            </td>
                        </tr>

                        <tr class=" pa-1" >
                            <td width="100%" align="center" colspan="2" :class=" props.item.latitudine == '-1.0' ? 'red darken-2 white--text': 'blue darken-2 white--text'">
                                GPS: {{ props.item.latitudine }},{{ props.item.longitudine }}
                            </td>
                        </tr>
                        <tr class="pa-1" >
                            <td width="50%" align="center">
                                <small>Inizio:  {{ props.item.dataIniCancello }} - {{ props.item.oraIniCancello }}</small>
                            </td>
                            <td width="50%" align="center">
                                <small>Fine:  {{ props.item.dataFineCancello }} - {{ props.item.oraFineCancello }}</small>
                            </td>
                            
                        </tr>

                        <tr class="pa-1 mb-2" style="height: 30px;">
                           
                            <td class="cardBottom" width="100%; height:30px" align="center" colspan="2">
                                <strong class="no-wrap"
                                    @click="stampaQRCode(props.item)">Stampa QR
                                    Code # {{ props.index + 1 }}</strong>
                            </td>
                        </tr>


                        

                        <tr v-if="classicMode" class=" pa-1">
                            <td class="cardBottom" width="50%" align="center">
                                <a :href="getTelegramLink(props.item.codiceAPP)">Link TELEGRAM - Operatore</a>
                            </td>
                            <td class="cardBottom" width="100%" align="center">
                                <span class="no-wrap"
                                    @click="stampaQRCode(props.item)">Stampa QR
                                    Code</span>
                            </td>
                        </tr>

                    </template>
                </v-data-table>
                <v-btn round class="black  white--text" @click="dettaglioCP = false">Chiudi</v-btn>

            </v-layout>

        </v-dialog>

        <v-dialog light persistent v-model="filtroDialog" width="340px" scrollable style="max-width:340px;">
            <v-layout align-center column justify-center class="cardStats" style="height:100%">
                <v-flex flex xs12 sm12 md12 lg12 class="mb-4 pa-2" style="width:100%">
                    <v-select :items="checkpoints" v-model="cpSelected" label="Selezionare un checkpoint" single-line
                        return-object persistent-hint hint="Checkpoint" @input="changedCP">
                        <template slot="selection" slot-scope="data">
                            {{ data.item.nome }}
                        </template>
                        <template slot="item" slot-scope="data">
                            {{ data.item.nome }}
                        </template>
                    </v-select>
                </v-flex>

                <!-- v-flex flex xs12 sm12 md12 lg12 class="mb-4 pa-2" style="width:100%">
                <v-select :items="listaCategorie" v-model="categoriaSelected" :label="'Categoria'" single-line persistent-hint :hint="'Categoria'" @input="changedCategoria"></v-select>
            </v-flex -->
                <v-flex flex xs12 sm12 md12 lg12 class="mb-4 pa-2" style="width:100%">
                    <v-layout align-start row wrap justify-center class="mt-1">
                        <v-btn small round outline class="red--text" @click="annullaFiltro()">Annulla filtro</v-btn>
                        <v-btn small round outline class="green--text" @click="filtroDialog = false">Applica</v-btn>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-dialog>
        <v-dialog light persistent v-model="dettaglio" class="cardUp white" width="1000px" scrollable
            style="max-width:1000px;">
            <v-layout v-if="messaggi" align-center column justify-center class="cardStats" style="height:100%">

                <div class="blue darken-4 white--text" style="width: 100%; height: 40px;">
                    <strong class="ml-2">Storico messaggi di {{ currentItem.cognome }} {{ currentItem.nome }} </strong>
                    <v-btn round outline small class="white  white--text" style="float: right;"
                        @click="dettaglio = false"><v-icon>close</v-icon></v-btn>
                    <v-btn round outline small class="white  white--text" style="float: right;"
                        @click="messaggi = false"><v-icon>arrow_back</v-icon></v-btn>
                </div>
                <v-layout v-if="numMessaggi == -1" align-center column justify-center
                    style="width: 100%; height: 400px;">
                    <h2>Caricamento messaggi...</h2>
                </v-layout>

                <div v-else style="height: 400px; width: 100%; background-color: white;">
                    <table v-if="currentItem != undefined && detailMessages.length > 0"
                        style="width: 100%; background-color: white;">
                        <tr v-for="(n, index) in getDetailMessages()" :key="'dettaglioMsgRow_' + index">
                            <td width="10%" class="frazioniTitle ">
                                <span class="mr-2">{{ getLabel(n.tipoMessaggio) }}</span>

                            </td>
                            <td width="5%" class="no-wrap pr-2">
                                <span class="mr-2">{{ (n.dataEvento) }}</span>
                            </td>
                            <!--td width="20%" align="left" class="no-wrap pr-2" > 
                                <v-icon @click="openWA(n)" class="ml-2" color="green darken-4" small>chat_bubble</v-icon>
                            </td-->
                            <td width="30%" class="no-wrap pr-2 red white--text"
                                v-if="n.data != undefined && n.data.toLowerCase() == 'aiuto'">
                                <strong class="ml-2"> {{ n.data }}
                                </strong>
                            </td>
                            <td width="20%" class="np-wrap pr-2" v-else>
                                <span v-if="n.tipoMessaggio !== 'image'" class="ml-2"> {{ n.data }}
                                </span>
                                <v-icon v-else @click="openImage(n.data)" class="ml-2"
                                    color="blue darken-4">photo</v-icon>



                            </td>
                            <td class="yellow pr-2"
                                v-if="n.note !== undefined && (n.note.indexOf('Attenzione') != -1 || n.note.indexOf('File:') != -1)">
                                <!-- v-icon @click="showResponse(n.note)" class="ml-2" color="blue darken-4" >list</v-icon -->
                                {{ getNota(n.note) }} <v-icon @click="validaFoto(n)" class="ml-2"
                                    color="red darken-4">settings</v-icon>
                            </td>
                            <td class="green white--text pr-2"
                                 v-else-if="n.note !== undefined && (n.note.indexOf('Complimenti !!!!') != -1 )">
                                {{ getNota(n.note) }}
                            </td>
                            <td class="orange black--text pr-2"
                                 v-else-if="n.note !== undefined && (n.note.indexOf('Non so rispondere a questo messaggio') != -1 )">
                                {{ getNota(n.note) }}
                            </td>
                            <td class="pr-2" v-else>
                                {{ getNota(n.note) }}
                                <!-- v-icon @click="showResponse(n.note)" class="ml-2" color="blue darken-4" >list</v-icon -->
                            </td>
                        </tr>
                    </table>
                </div>


            </v-layout>
            <v-layout v-else align-center column justify-center class="cardStats" style="height:100%">
                <table v-if="currentItem != undefined" style="width: 100%" class="">
                    <tr>
                        <td width="70%" class="cardStatsHeader  pa-1" colspan=4>
                            <strong style="float: left">
                                <span class="mr-2 ml-1 white--text">{{ currentItem.pett }}</span>

                                <country-flag :country="currentItem.nazione" size="small" class="" />
                                {{ currentItem.cognome }}
                                {{ currentItem.nome }}
                                <br />
                                <span class="ml-5">
                                    <small>{{
                                        currentItem.squadra
                                    }} </small></span>
                            </strong>
                            <v-icon @click="dettaglio = false" class="ma-0 pa-0 white--text"
                                style="float:right">close</v-icon>
                        </td>
                    </tr>
                </table>
                <table v-if="currentItem != undefined" style="width: 100%" class="mb-3">
                    <!--tr>
                        <td width="40%" class="pr-2 frazioniTitle frazioniValueR"><strong>Codice per assistente
                                virtuale</strong></td>
                        <td width="60%" class="pl-2"><strong>ARI:{{
                            this.$route.query.idEvento
                        }}-{{ currentItem.pett }}</strong> </td>
                    </tr-->
                    <!--tr>
                        <td width="40%" class="pr-2 frazioniTitle frazioniValueR"><strong>Chat tra organizzatore e atleta</strong></td>
                        <td width="60%" class="pl-2">
                            <a target="_blank" class="black--text"
                                :href="'https://api.whatsapp.com/send/?phone=%2B39' + currentItem.telefono + '&text=Ciao ' + currentItem.nome + ',%0a%0a&type=phone_number&app_absent=0'">Invia
                                messaggio generico</a>
                            <a target="_blank" class="black--text ml-2"
                                :href="'https://api.whatsapp.com/send/?phone=%2B39' + currentItem.telefono + '&text=Ciao ' + currentItem.nome + ',%0a%0aeccoti il link per abilitare l\'assistente virtuale ICRON che dovrai utilizzare durante la manifestazione ' + rankTitle + '.%0a%0ahttps:\/\/api.whatsapp.com\/send\/?phone=%2B393792397100%26text=ARI:' + this.$route.query.idEvento + '-' + currentItem.pett + '%0a%0aClicca sul link per aprire la chat Whatsapp ed inviare il tuo numero di registrazione alla manifestazione.%0a%0aSe hai problemi ad aprire il link puoi metterti in rubrica il numero dell\'assistente virtuale 3792397100 e invia il messaggio tramite Whatsapp (compreso la scritta ARI:):%0a%0a*ARI:' + this.$route.query.idEvento + '-' + currentItem.pett + '*&type=phone_number&app_absent=0'">Invia
                                link registrazione</a>
                        </td>
                    </tr-->
                    <tr v-if="currentItem.attivo">
                        <td width="40%" class="pr-2 frazioniTitle frazioniValueR"><strong>Chat tra assitente e atleta</strong></td>
                        <td width="60%" class="pl-2">
                            <span class="ml-2 v-btn" @click="inviaMessaggio = true">Invia messaggio da Assistente</span>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2"></td>
                    </tr>
                    <tr v-for="n in getDetailFields()" :key="'dettaglioRow' + n.id">
                        <td v-if="n.label !== ''" width="40%" class="pr-2 frazioniTitle frazioniValueR">
                            <strong>{{ n.label }}</strong>
                        </td>
                        <td v-else width="40%" class="white">
                            <strong class="mr-2">{{ n.label }}</strong>
                        </td>
                        <td width="60%" :style="n.style">
                            <span class="ml-2">{{ getFieldValue(currentItem, n) }}
                                <span v-if="getFieldValue(currentItem, n)">
                                    <!-- v-icon v-if="n.columnName.startsWith('CK')"
                                        @click="openLink(getLink(getFieldValue(currentItem, n), n, currentItem.pett))"
                                        class="ml-2" color="red" small>visibility</v-icon -->
                                </span>
                                <span v-else>
                                    <span v-if="n.columnName.startsWith('CK')">
                                        <v-icon @click="addRilev(n)" class="ml-2" color="red" small>add</v-icon>
                                    </span>
                                </span>
                            </span>
                        </td>
                    </tr>
                </table>
                <div v-if="currentItem != undefined">
                    <!--v-btn round small class="grey black--text" @click="inviaEmail()">Invia email</v-btn-->
                    <v-btn v-if="currentItem.stato != 'NON PARTITO' && currentItem.stato != 'RITIRATO'" round small
                        class="red  white--text" @click="ritiro()">Registra ritiro</v-btn>
                    <v-btn round outline small class="black  black--text" @click="loadDettaglio(currentItem)">Vedi
                        messaggi</v-btn>
                    <v-btn round outline small class="black  black--text" @click="dettaglio = false">Chiudi</v-btn>


                </div>
            </v-layout>
        </v-dialog>

        <v-dialog v-model="aggiungiTempo" width="500px" persistent scrollable style="max-width:340px;">
            <v-card style="margin-top:0px; border-radius:5px;">
                <v-card-title class="pt-2 blue darken-4">
                    <v-icon @click="annullaRil()" white
                        style="float:right;  margin-right:15px; color: white">clear</v-icon>
                    <span style="color: white; margin-top:10px;" class="ma-3 "><strong>Aggiungi
                            rilevamento</strong></span>
                </v-card-title>
                <v-card-text class="pt-4">
                    <div>
                        Aggiungere l'orario di passaggio nel formato ANNO-MM-GG HH:mm (es. 2023-01-25 12:35) al
                        checkpoint <strong> {{ currentCP.codiceAPP }}</strong> in località <strong>{{
                            currentCP.localita
                        }} {{ currentCP.nome }}</strong><br><br>
                        <v-text-field label="Nuovo valore" v-model="valueSelected" mask="####-##-## ##:##"
                            return-masked-value outline clearable></v-text-field>
                    </div>
                </v-card-text>
                <v-card-actions class="ma-4">
                    <v-layout class="mt-4">
                        <v-layout align-center row justify-center>
                            <v-btn round primary @click="annullaRil()">Annulla</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn round class="blue darken-4 white--text" @click="salvaRil()">OK</v-btn>
                        </v-layout>
                    </v-layout>
                </v-card-actions>
            </v-card>
        </v-dialog>


        <v-dialog v-model="inviaMessaggio" width="500px" persistent scrollable style="max-width:340px;">
            <v-card style="margin-top:0px; border-radius:5px;">
                <v-card-title class="pt-2 blue darken-4">
                    <v-icon @click="annullaRil()" white
                        style="float:right;  margin-right:15px; color: white">clear</v-icon>
                    <span style="color: white; margin-top:10px;" class="ma-3 "><strong>Invia messaggio tramite assistente</strong></span>
                </v-card-title>
                <v-card-text class="pt-4">
                    <div>
                        <v-text-field label="Messaggio" v-model="messaggioSelected"  outline clearable></v-text-field>
                    </div>
                </v-card-text>
                <v-card-actions class="ma-4">
                    <v-layout class="mt-4">
                        <v-layout align-center row justify-center>
                            <v-btn round primary @click="inviaMessaggio=false">Annulla</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn round class="green darken-4 white--text" @click="inviaWA()">Invia</v-btn>
                        </v-layout>
                    </v-layout>
                </v-card-actions>
            </v-card>
        </v-dialog>


        <v-dialog v-model="validaTempo" width="1000px" persistent scrollable style="max-width:1000px;">
            <v-layout align-center row justify-center style="height:100%" class="white">
              
                <v-flex flex xs12 sm12 md12 lg12>
                    <v-card style="margin-top:0px; border-radius:5px;">
                        <v-card-title class="pt-2 blue darken-4">
                            <v-icon @click="validaTempo = false" white
                                style="float:right;  margin-right:15px; color: white">clear</v-icon>
                            <span style="color: white; margin-top:10px;" class="ma-3 "><strong>Valida foto {{
                                selectedTime
                            }}</strong></span>
                        </v-card-title>
                        <v-card-text class="pt-4">
                            <div>
                                Aggiungere il checkpoint che vedi in foto oppure marcalo come selfie
                                <br><br>
                                <v-select :items="checkpoints" v-model="checkpointSelected" label="" single-line
                                    return-object persistent-hint hint="Checkpoint">
                                    <template slot="selection" slot-scope="data">
                                        {{ data.item.nome }}
                                    </template>
                                    <template slot="item" slot-scope="data">
                                        {{ data.item.codiceAPP }} - {{ data.item.nome }}
                                    </template>
                                </v-select>


                            </div>
                        </v-card-text>
                        <v-card-actions class="ma-4">
                            <v-layout class="mt-4">
                                <v-layout align-center row justify-center>
                                    <v-btn round primary @click="validaTempo = false">Annulla</v-btn>
                                    <v-spacer></v-spacer>
                                    <v-btn round class="orange darken-4 black--text"
                                        @click="salvaSelfie()">SELFIE</v-btn>
                                    <v-spacer></v-spacer>
                                    <v-btn round class="blue darken-4 white--text" @click="salvaTempo()">OK</v-btn>
                                </v-layout>
                            </v-layout>
                        </v-card-actions>
                    </v-card>
                    <v-img v-if="selectedConversation.data !== undefined" :src="'https://www.icron.it/'+selectedConversation.data"
                            height="100%" width="400px"></v-img>
                </v-flex>

            </v-layout>

        </v-dialog>



        <!-- v-dialog light persistent v-model="flussomessaggi" class="cardUp" width="1000px" scrollable style="max-width:1000px;">
            <v-layout align-center column justify-center class="cardStats " style="height:100%">
                <div class="blue darken-4 white--text" style="width: 100%; height: 40px;">
                    <strong class="ml-2">Storico messaggi</strong> 
                    <v-btn round outline small class="white  white--text" style="float: right;" @click="flussomessaggi = false">X</v-btn>

                </div>
              
                <div style="height: 400px; width: 100%; background-color: white;" >
                    <table v-if="detailFlowMessages.length > 0" style="width: 100%;  background-color: white;"  >
                        <tr v-for="(n, index) in detailFlowMessages" :key="'dettaglioMsgRow_' + index">
                            <td width="20%" class="frazioniTitle ">
                                <span class="mr-2">{{ getLabel(n.tipoMessaggio) }}</span>
                            </td>
                            <td width="100px" align="left" class="pr-2">
                                <span class="mr-2">{{ (n.dataEvento) }}</span>
                            </td>
                            <td width="20%" align="left" class="no-wrap pr-2" >
                                <v-icon @click="openDettaglio(n.idiscrizione)" class="mr-2" color="blue darken-4" >person</v-icon>
                                <span class="mr-2">{{ n.cognome }}<br>{{ n.nome }}</span>
                            </td>
                            <td width="40%" class="no-wrap pr-2 red white--text" v-if="n.data == 'aiuto' "  >
                                <strong class="ml-2"> {{ n.data }} 
                                </strong>
                            </td>
                            <td width="40%" class="no-wrap pr-2" v-else  >
                                <span v-if="n.tipoMessaggio !== 'image'" class="ml-2"> {{ n.data }} 
                                </span>
                                <v-icon v-else @click="openImage(n.data)" class="ml-2" color="blue darken-4" >photo</v-icon>
                            </td>
                            <td width="10%" class="red pr-2" v-if="n.note !== undefined && n.note.indexOf('Attenzione') != -1" >
                                {{ getNota(n.note) }}
                            </td>
                            <td width="10%" class="pr-2" v-else >
                                {{ getNota(n.note) }}

                            </td>
                        </tr>
                    </table>
                    
                </div>
            </v-layout>
        </v-dialog -->


        <v-toolbar app color="white">
            <img class="menuLogo ml-0 mt-0 mb-2" src="../assets/loghi/logo_icron_2.0.png" @click="gotoHome()"
                style="height: 40px" />
            <v-spacer></v-spacer>
            <!--img class="menuLogo ml-4 mt-2 mb-2" src="../assets/images/logoRacehard.png" style="height: 40px"   / -->
            <v-spacer></v-spacer>
            <span v-if="showPrint" class="mr-4">
                <v-icon @click="print()">print</v-icon>
            </span>
            <span v-if="isAdmin()" class="mr-4">
                <v-icon color="red" @click="download(true)">download</v-icon>
            </span>
            
            <span class="mr-4">
                <v-icon v-if="!flussomessaggi" @click="apriFlussoMessaggi()">chat_bubble</v-icon>
                <v-icon v-else @click="flussomessaggi = false">groups</v-icon>
            </span>
            <span class="mr-4">
                <v-icon @click="refreshAll()">refresh</v-icon>
            </span>
           
            <span class="mr-4">
                <v-icon @click="stats = true">equalizer</v-icon>
            </span>
            <span class="mr-4" v-if="showFilter !== undefined">
                <v-icon :class="getClasseFiltro()" @click="filtroDialog = true">filter_list</v-icon>
            </span>
            <span class="mr-2">
                <v-icon :class="filterToggle ? 'red--text' : ''" @click="toggleSearch()">search</v-icon>
                <span v-if="filterToggle && flussomessaggi" class="ml-4 ">
                    {{ detailFlowMessagesF.length }}
                </span>
                <span v-if="filterToggle && !flussomessaggi" class="ml-4 ">
                    {{ itemsF.length }}
                </span>
            </span>
        
            <v-layout align-start row wrap justify-center :class="color + '  darken-2 p-2  v-toolbar--fixed'"
                style="width:100%; margin-top:55px">
                <span class="white--text"><strong>{{ rankTitle }}</strong>
                    <v-icon @click="raceInfo = true" class="ml-4" small color="white">info</v-icon>
                </span>
                <span class="ml-4" v-if="classicMode">
                    <v-icon color="white darken-4" small @click="openCartediViaggio()">maps</v-icon>
                </span>

            </v-layout>
            <!--v-layout v-if="isMobileMode()" align-end row wrap justify-end :class=" color + '  darken-2 p-2  v-toolbar--fixed ml-1'" style="margin-top:55px"> <strong>{{ raceTime }}</strong>
        </v-layout-->
        </v-toolbar>
        <v-layout v-if="false && isMobileMode() && configOK && !flussomessaggi" align-start row wrap justify-center
            class="mt-4 mb-4">
            <v-flex flex xs12 sm12 md12 lg12>
                <v-data-table :items="itemsF" hide-actions hide-headers class="elevation-1 mb-5"
                    style="width: 100%; border: 0px">
                    <template slot="items" slot-scope="props">
                        <tr style="height:1px">
                            <td style="height:1px" colspan="3"></td>
                        </tr>
                        <tr class="pa-2 " v-if="props.item.cognome !== ''">
                            <td colspan="3" class="cardUp pa-1" style="">
                                <span style="float: left">
                                    <small class="ml-0 mr-2"></small>

                                    <country-flag :country="props.item.nazione" size="small" />
                                    <strong class="ml-1">{{ props.item.cognome }}
                                        {{ props.item.nome }} </strong>
                                </span>
                                <span @click="setCurrentItem(props.item)" class="mt-1 p-0"
                                    style="float: right; color: white; margin-right: 10px;  ">
                                    <v-icon class="black--text pa-0">list</v-icon>
                                </span>
                            </td>
                        </tr>

                        <tr v-if="props.item.cognome !== ''">
                            <td width="3%" style="background-color: lightgray;" class="no-wrap">
                                <small class="ml-2"> {{ props.item.lastCPTime }} </small>
                            </td>
                            <td width="37%" class="frazioniValueRow no-wrap">
                                <strong>{{ props.item.lastCP }}</strong>
                            </td>
                            <td width="20%" align="center" :class="getColor(props.item.numCP) + ' no-wrap'">
                                <strong>{{ (props.item.numCP) }} / {{ checkpoints.length }}</strong>
                            </td>
                        </tr>

                    </template>
                </v-data-table>
            </v-flex>
        </v-layout>



        <v-layout v-if="isMobileMode() && configOK && !flussomessaggi" align-start row wrap justify-center
            class="mt-4 mb-4">
            <v-flex flex xs12 sm12 md12 lg12>
                <v-data-table :items="itemsF" hide-actions hide-headers class="elevation-1 mb-5"
                    style="width: 100%; border: 0px">
                    <template slot="items" slot-scope="props">
                        <tr style="height:1px">
                            <td style="height:1px" colspan="3"></td>
                        </tr>
                        <tr class="pa-2 " v-if="props.item.cognome !== ''">
                            <td colspan="3" class="cardUp pa-1" style="">
                                <span style="float: left">
                                    <small class="ml-0 mr-2"></small>

                                    <country-flag :country="props.item.nazione" size="small" />
                                    <strong class="ml-1">{{ props.item.cognome }}
                                        {{ props.item.nome }} </strong> <!--v-icon  class="ml-2"
                                    :color="props.item.attivo !== undefined ? 'green darken-4' : 'red darken-4'"
                                    small>star</v-icon-->
                                </span>
                                <span @click="setCurrentItem(props.item)" class="mt-1 p-0"
                                    style="float: right; color: white; margin-right: 10px;  ">
                                    
                                    <v-icon class="black--text pa-0">list</v-icon>
                                </span>
                            </td>
                        </tr>

                        <tr v-if="props.item.cognome !== ''">
                            <td width="3%" style="background-color: lightgray;" class="no-wrap">
                                <small class="ml-2"> {{ props.item.lastCPTime }} </small>
                            </td>
                            <td width="37%" class="frazioniValueRow no-wrap">
                                <strong>{{ props.item.lastCP }}</strong>
                            </td>
                            <td width="20%" align="center" :class="getColor(props.item.numCP) + ' no-wrap'">
                                <strong>{{ (props.item.numCP) }} / {{ checkpoints.length }}</strong>
                            </td>
                        </tr>

                    </template>
                </v-data-table>
            </v-flex>
        </v-layout>


        <v-layout v-if="flussomessaggi && configOK && isDesktopMode()" align-start row wrap justify-center
            :class="this.showButtons ? 'mt-4' : 'mt-1'">
            <v-flex flex xs12 sm12 md12 lg12 class="mb-5">
                <table v-if="detailFlowMessagesF.length > 0" style="width: 100%;  background-color: white;">
                    <tr v-for="(n, index) in getDetailFlowMessagesF()" :key="'dettaglioMsgRow_' + index">
                        <td width="5%" class="no-wrap frazioniTitle ma-2 pa-2 ">
                            <span class="mr-2">{{ getLabel(n.tipoMessaggio) }}</span>
                        </td>
                        <td width="10%" align="center" class="no-wrap pr-2">
                            <span class="mr-2">{{ (n.dataEvento) }}</span>
                        </td>
                        <td width="20%" align="left" class="no-wrap pr-2">
                            <v-icon @click="openDettaglio(n.idiscrizione)" class="mr-2"
                                color="blue darken-4">person</v-icon>
                            <span class="mr-2">{{ n.cognome }} {{ n.nome }}</span>
                            <!--v-icon @click="openWA(n)" class="ml-2" color="green darken-4" small>chat_bubble</v-icon -->
                        </td>
                        <td class="no-wrap pr-2 red white--text"
                            v-if="n.data !== undefined && (n.data.toLowerCase() == 'aiuto' || n.data.toLowerCase() == 'help'  || n.data.toLowerCase() == 'ritiro') ">
                            <strong class="ml-2"> {{ n.data }}
                            </strong>
                        </td>
                        <td class="pr-2" v-else>
                            <span v-if="n.tipoMessaggio !== 'image'" class="ml-2"> {{ n.data}}
                            </span>
                            <v-icon v-else @click="openImage(n.data)" class="ml-2" color="blue darken-4">photo</v-icon>
                        </td>
                        <td class="yellow pr-2"
                            v-if="n.note !== undefined && (n.note.indexOf('Attenzione') != -1 || n.note.indexOf('File:') != -1  )">
                            <!-- v-icon @click="showResponse(n.note)" class="ml-2" color="blue darken-4" >list</v-icon -->
                            {{ getNota(n.note) }}
                            <v-icon @click="validaFoto(n)" class="ml-2" color="red darken-4">settings</v-icon>
                        </td>
                        <td  class="green white--text pr-2"
                                v-else-if="n.note !== undefined && (n.note.indexOf('Complimenti !!!!') != -1 )">
                                {{ getNota(n.note) }}
                        </td>
                        <td  class="orange black--text pr-2"
                                v-else-if="n.note !== undefined && (n.note.indexOf('Non so rispondere a questo messaggio') != -1 )">
                                {{ getNota(n.note) }}
                        </td>
                        <td  class="red white--text pr-2"
                                v-else-if="n.note !== undefined && (n.note.indexOf('ritiro') != -1  || n.note.indexOf('aiuto') != -1)">
                                {{ getNota(n.note) }}
                        </td>
                        <td class="pr-2 white black--text" v-else>
                                {{ getNota(n.note) }}
                                <!-- v-icon @click="showResponse(n.note)" class="ml-2" color="blue darken-4" >list</v-icon -->
                        </td>
                       
                    </tr>
                </table>
            </v-flex>
        </v-layout>


        <v-layout v-if="flussomessaggi && configOK && isMobileMode()" align-start row wrap justify-center
            :class="this.showButtons ? 'mt-4' : 'mt-1'">
            <v-flex flex xs12 sm12 md12 lg12 class="mb-5" v-if="detailFlowMessagesF.length > 0">
                <div v-for="(n, index) in getDetailFlowMessagesF()" :key="'dettaglioMsgRow_' + index">
                    <hr>

                    <div>
                        <span class="mr-2">{{ (n.dataEvento) }}</span>
                    </div>
                    <span class="mr-2" style="float: right;">{{
                        getLabel(n.tipoMessaggio)
                    }}</span>
                    <span class="mr-2"> <v-icon @click="openDettaglio(n.idiscrizione)" class="mr-2"
                            color="blue darken-4">person</v-icon>
                        <span class="mr-2">{{ n.cognome }} {{ n.nome }}</span></span>
                    <div>
                        <span v-if="n.tipoMessaggio !== 'image'"> {{ n.data }}
                        </span>
                        <v-icon v-else @click="openImage(n.data)" color="blue darken-4">photo</v-icon>
                    </div>
                    <div class="pa-2">
                        <span class="yellow" style="word-wrap:break-word;"
                            v-if="n.note !== undefined && (n.note.indexOf('Attenzione') != -1 || n.note.indexOf('File:') != -1)">
                            <!-- v-icon @click="showResponse(n.note)" class="ml-2" color="blue darken-4" >list</v-icon -->
                            <small>
                                {{ getNota(n.note) }}
                            </small>
                            <v-icon @click="validaFoto(n)" class="ml-2"
                                    color="red darken-4">settings</v-icon>
                        </span>
                        <span v-else-if="n.note.indexOf('Non so rispondere a questo messaggio') != -1" style=" word-wrap:break-word;" class="orange">
                            <small>
                                {{ getNota(n.note) }}
                            </small>
                            <!-- v-icon @click="showResponse(n.note)" class="ml-2" color="blue darken-4" >list</v-icon -->
                        </span>
                        <span v-else style=" word-wrap:break-word;">
                            <small>
                                {{ getNota(n.note) }}
                            </small>
                            <!-- v-icon @click="showResponse(n.note)" class="ml-2" color="blue darken-4" >list</v-icon -->
                        </span>
                    </div>


                </div>
            </v-flex>
        </v-layout>


        <v-layout v-if="isDesktopMode() && !flussomessaggi && configOK" align-start row wrap justify-center
            :class="this.showButtons ? 'mt-4' : 'mt-1'">

            <v-flex v-if="!flussomessaggi" flex xs12 sm12 md12 lg12 class="mb-5">
                <v-data-table :items="itemsF" hide-actions style="width: 100%;" class="mb-5">
                    <template slot="headers" slot-scope="props">
                        <tr class="" style="background-color: #f5f5f5 !important; height:20px">
                            <!--th></th-->
                            <th v-for="n in getFields() " :key="'intermedioTh' + n.id"
                                class="black--text text-xs-center" @click="orderBy(n)"><strong>{{
                                    n.label.toUpperCase()
                                }}</strong></th>
                        </tr>
                    </template>
                    <template slot="items" slot-scope="props">
                        <tr style="height:0px">

                        </tr>
                        <tr v-if="props.item.cognome !== ''">
                            <!--td>
                                <v-icon @click="setCurrentItem(props.item, n)" class="ml-2"
                                    :color="props.item.attivo !== undefined ? 'green darken-4' : 'red darken-4'"
                                    small>visibility</v-icon>
                            </td-->

                            <td @click="setCurrentItem(props.item, n)" v-for="n in getFields()"
                                :key="'intermedioRow' + n.id" :style="n.style"
                                :class="getClass(getFieldValue(props.item, n))">
                                <span v-if="n.label !== 'naz'">{{ getFieldValue(props.item, n) }}</span>
                                <span v-if="n.label === 'naz'">
                                    <country-flag :country="props.item.nazione" size="small" /></span>
                            </td>
                        </tr>
                        <tr v-else>
                            <td style="background-color: white; color: #0D3D58; text-align: center ">
                                <strong>{{ getValoreMobile(props.item, 'detailField_R10') }}</strong>
                            </td>
                            <td :colspan="getFields().length - 1"
                                style="background-color: white; color: #0D3D58; text-align: center ">
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-flex>




        </v-layout>
        <v-layout v-if="!configOK" align-start row wrap justify-center class="mt-4 ">
            <v-flex flex xs12 sm12 md12 lg12 class="mb-5">
                <v-layout class="justify-center">
                    <h1>Caricamento dati....</h1>
                </v-layout>
            </v-flex>
        </v-layout>
        <v-footer v-if="filterToggle" fixed class="p-0 grey darken-2" style="height: 30px;">
            <v-layout align-start row wrap justify-center :class="color + '  darken-2 p-0 m-0 '" style="width:100%; ">
                <v-flex flex xs12 sm12 md12 lg12 class="white pa-2">
                    <v-text-field class="white red--text pa-0" style="width:100%;" v-model="searchText"
                        label="Cerca cognome, team o pettorale" outline clearable append-icon="search"
                        @input="changedSearch"></v-text-field>
                </v-flex>
            </v-layout>
        </v-footer>
        <v-footer v-if="!filterToggle && isDesktopMode()" fixed class="black white--text"
            style="height: 30px; padding: 10px">
            <v-layout align-start row wrap justify-center style="width:100%; ">
                <v-flex flex xs12 sm6 md6 lg6 class="pa-2">
                    <span @click="filterState('iscritti')" class="grey black--text pa-1"
                        style="float:left">Iscritti:<strong> {{
                            numeroTotaleIscritti
                        }}</strong>
                    </span>
                    <!--span class="blue darken-4 white--text ml-2 pa-1" style="float:left">Registrati:<strong> {{
                        numeroTotaleRegistrati
                    }}</strong>
                    </span-->
                    <span @click="filterState('partiti')" class="white black--text ml-2 pa-1"
                        style="float:left">Partiti:<strong> {{ numRilevati }}</strong> </span>
                    <span @click="filterState('ritirati')" class="red darken-4 white--text ml-2 pa-1"
                        style="float:left">Ritirati:<strong> {{
                            numeroTotaleRitirati
                        }}</strong>
                    </span>
                    <span @click="filterState('attivi')" class="black--text ml-2 yellow pa-1" style="float:left">In
                        attività:<strong> {{
                            numeroTotaleAttivi
                        }}</strong>
                    </span>
                    <span @click="filterState('completati')" class="green darken-2 white--text ml-2 pa-1"
                        style="float:left">Arrivati:<strong> {{
                            numeroTotaleArrivati
                        }}</strong>
                    </span>
                    <span @click="filterState('completati')" class="blue darken-2 white--text ml-2 pa-1"
                        style="float:left">Brevettati:<strong> {{
                            numeroTotaleCompletati
                        }}</strong>
                    </span>
                </v-flex>
                <v-flex flex xs12 sm6 md6 lg6 class="pa-2">
                    <span class="ml-4" style="float:right" @click="dettaglioCP = true">
                        <v-icon color="red darken-4" small>place</v-icon>
                        Elenco/Stampa Checkpoint
                    </span>
                </v-flex>
            </v-layout>

            <!--span @click="mostraAssenti" class="white--text ml-2 grey pl-2 pr-2" style="float:right">MOSTRA ASSENTI </span -->
        </v-footer>

        <v-footer v-if="!filterToggle && isMobileMode()" fixed class="black white--text"
            style="height: 90px; padding: 0px">
            <v-layout align-start row wrap justify-center style="width:100%; ">
                <v-flex flex xs12 sm6 md6 lg6>
                    <table style="width: 100%;">
                        <tr>
                            <td align="center"><small>Iscritti</small></td>
                            <!--td align="center"><small>Registrati</small></td-->
                            <td align="center"><small>Partiti</small></td>
                            <td align="center"><small>Ritirati</small></td>
                            <td align="center"><small>Attivi</small></td>
                            <td align="center"><small>Arrivati</small></td>
                            <td align="center"><small>Completati</small></td>
                        </tr>
                        <tr>
                            <td width="15%" align="center" @click="filterState('iscritti')"
                                class="no-wrap grey black--text"><strong> {{
                                    numeroTotaleIscritti
                                }}</strong>
                            </td>
                            <!--td width="15%" align="center" class="no-wrap blue darken-4 white--text"><strong> {{
                                numeroTotaleRegistrati
                            }}</strong>
                            </td-->
                            <td width="15%" align="center" @click="filterState('partiti')" class="white black--text">
                                <strong> {{
                                    numRilevati
                                }}</strong>
                            </td>
                            <td width="15%" align="center" @click="filterState('ritirati')"
                                class="no-wrap red darken-4 white--text "><strong> {{
                                    numeroTotaleRitirati
                                }}</strong>
                            </td>
                            <td width="15%" align="center" @click="filterState('attivi')"
                                class="black--text ml-0 mt-1 yellow pa-1"><strong> {{
                                    numeroTotaleAttivi
                                }}</strong>
                            </td>
                            <td width="15%" align="center" @click="filterState('arrivati')"
                                class="green darken-2 white--text"><strong> {{
                                    numeroTotaleArrivati
                                }}</strong>
                            </td>
                            <td width="15%" align="center" @click="filterState('completati')"
                                class="blue darken-2 white--text"><strong> {{
                                    numeroTotaleCompletati
                                }}</strong>
                            </td>
                        </tr>
                    </table>



                    <v-layout align-start row wrap justify-center style="width:100%; " class="mt-2">

                        <div @click="dettaglioCP = true">
                            <v-icon color="red darken-4" small>place</v-icon>
                            Elenco/Stampa Checkpoint
                        </div>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-footer>
    </div>
</template>

<script>
const moment = require('moment');

export default {

    components: {
        //      live: LiveRanking,
    },
    name: 'Classifica',

    data() {
        return {
            items: [],
            itemsF: [],

            showButtons: true,
            showPrint: false,
            showDownload: false,

            compatta: true,
            categoriaSelected: 'TUTTE',
            cpSelected: undefined,
            divisioneSelected: 'TUTTE',
            listaCategorie: [],
            listaSesso: ['TUTTI', 'MASCHILE', 'FEMMINILE'],
            filterToggle: false,
            filterPreferiti: false,
            listaPreferiti: {},

            listaCampi: [],
            listaCampiDettaglio: [],

            searchText: '',

            raceID: null,
            rankTitle: '',

            configEvento: {},
            elencoClassifica: [],
            tagFile: null,

            myInterval: null,
            sport: '',

            stats: false,
            loaded: false,
            dettaglio: false,
            currentItem: null,

            value: 0,
            bufferValue: 100,
            interval: 0,
            pause: false,
            indexTo: -1,

            mappaIntermedi: {},

            local: undefined,

            fields: [],
            detailFields: [],

            color: 'blue',
            baseStyle: 'white:black',

            filtroDialog: false,

            orderByField: null,
            direction: true,

            configOK: false,

            numRilevati: 0,
            numeroTotaleIscritti: 0,
            numeroTotaleAttivi: 0,
            numeroTotaleRitirati: 0,
            numeroTotaleCompletati: 0,
            numeroTotaleArrivati: 0,



            confDefault: false,

            cambiaGaraToggle: false,

            divisioneCorrente: '',

            urlARI: null,
            urlICRON: null,

            showFilter: true,

            checkpoints: [],

            viewSelected: 'TUTTI',

            dettaglioCP: false,

            raceInfo: false,

            botId: 1,

            classicMode: false,

            aggiungiTempo: false,
            valueSelected: '',
            currentCP: {},

            messaggi: false,
            detailMessages: [],

            flussomessaggi: false,
            detailFlowMessages: [],
            detailFlowMessagesF: [],

            numeroTotaleRegistrati: 0,

            numMessaggi: -1,

            validaTempo: false,

            listaCheckpoints: ['Selfie'],
            checkpointSelected: null,

            selectedTime: "",

            selectedConversation: {},

            inviaMessaggio: false,
            messaggioSelected: "",

            conversazioniAttive: {}



        };
    },

    beforeDestroy() {
        clearInterval(this.myInterval);
        // clearInterval(this.myInterval);
    },

    mounted() {
        console.log(this.$route.params.raceID);
        this.raceID = this.$route.params.raceID;
        this.paramID = this.$route.params.id;
        this.local = this.$route.params.local;

        console.log("SOURCE >>" + this.$route.query.source);
        console.log("TOKEN >>" + this.$route.query.token);
        console.log("IDEVENTO >>" + this.$route.query.idEvento);
        console.log("BOTID >>" + this.$route.query.botId);

        let uri = window.location.href.split("?");

        console.log("URI:" + uri);
        let base = "";

        if (this.$route.query.botId !== undefined) {
            this.botId = this.$route.query.botId;
        }

        if (this.$route.query.source === "ARI") base = base + "ari/gestione/";
        else base = base + "checkpointServices/gestioneGaraCheckpoint/";
        let url1 = "";
        //url1 = base + '/IcronNewGO/ari/gestione/1726/kvmL2ypKloKMjfk-HTBJVa8aa6DqV4lIJPrO_lS-1gk=';
        //url1 = base + '/IcronNewGO/ari/gestione/1691/a52f9EYz7zIii-hNYf-lQeoKe3WAeEM7g4rbHq7iVB0=';
        url1 = base + this.$route.query.idEvento + "/" + this.$route.query.token;

        this.urlARI = url1;

        this.urlICRON = "/ari/elencoBrevetti/" + this.$route.query.idEvento + "/" + this.$route.query.token;

        this.urlDettaglio = "ari/getConversazioniSessioneEvento/" + this.$route.query.idEvento + "/" + this.$route.query.token;

        this.urlSalvaRilevamento = "ari/registraRilevamentoDaConsole/" + this.$route.query.idEvento + "/" + this.$route.query.token;

        this.urlInviaMessaggioWA = "/ari/inviaMessaggioWhatsapp/" + this.$route.query.idEvento + "/" + this.$route.query.token;

        this.urlRegistraRitiro = "ari/aggiungiStatoRilevamentoApp/" + this.$route.query.idEvento + "/" + this.$route.query.token;


        console.log(url1)
        this.loadEvento();
    },

    methods: {
        isAdmin() {
            return false;
        },

        forceReload() {
            window.location.reload();
        },

        toggleSearch() {
            this.filterToggle = !this.filterToggle;
            window.scrollTo(0, 0);
        },

        loadEvento() {
            this.getEventoARI(this.urlARI).then((response) => {
                console.log(">>" + (response) + "<<");
                if (response !== '') {
                    this.configRace(response);
                } else {
                    /* console.log("Configurazione di default")
                     const _url = this.getDataURL() + "getFile?idGara=base&fileName=rankConfigurationBASE.txt";;
                     console.log(_url);
                     this.getRemoteService(_url).then((response) => {
                         console.log(">>" + (response) + "<<");
                         this.confDefault = true;
                         if (response !== '') {
                             this.configRace(response);
                         } else {
                            alert("Nessuna configurazione disponibile" );
                         }
                     });*/

                }
            }); //fine
        },

        apriFlussoMessaggi() {

            // this.loadFlussoMessaggi()

            this.flussomessaggi = true

        },

        loadFlussoMessaggi() {
            console.log("loadFlussoMessaggi")
            this.numeroTotaleRegistrati = 0;
            //this.detailFlowMessages = []
            this.getDettaglioEventoARI(this.urlDettaglio, undefined).then((response) => {
                //console.log(">>" + (response) + "<<");
                this.detailFlowMessages = response.listaConversazioni;

                this.conversazioniAttive = {};
                
                let selfies = {};
                if (this.detailFlowMessages !== undefined) {
                    this.detailFlowMessages.forEach(conv => {
                        //console.log( conv.note );
                        if (this.conversazioniAttive[conv.idiscrizione] == undefined) this.conversazioniAttive[conv.idiscrizione] = [];
                        this.conversazioniAttive[conv.idiscrizione].push(conv);
                        
                        if (conv.note != null && conv.note.indexOf('Il tuo selfie è stato taggato correttamente') != -1)
                            selfies[conv.idiscrizione] = true;

                    })

                }

                let temp = [];
                if (this.itemsF !== undefined) {
                    this.itemsF.forEach(p => {
                        p.attivo = this.conversazioniAttive[p.id] !== undefined;
                        if (p.attivo == true)
                            this.numeroTotaleRegistrati++;
                        temp.push(p);

                        p.selfie = selfies[p.id] ? 'SI' : 'NO'


                    })
                    this.itemsF = temp;
                }

                this.detailFlowMessagesF = [];
                this.detailFlowMessagesF = this.filterMessages();

            });
        },

        getDetailFlowMessagesF() {
            return this.detailFlowMessagesF;
        },


        loadDettaglio(item) {
            console.log("loadDettaglio")
            this.detailMessages = []

            /*this.detailMessages = this.detailFlowMessages.filter( p => {
                return  p.idiscrizione == item.id
            })*/
            this.messaggi = true;
            this.numMessaggi = -1;

            this.getDettaglioEventoARI(this.urlDettaglio, item.id).then((response) => {
                console.log(">>" + (response) + "<<");

                this.detailMessages = response.listaConversazioni;
                this.numMessaggi = this.detailMessages.length;;
            });
        },


        loadAggiornamentoDati() {
            this.getAggiornamentoDatiARI(this.urlICRON).then((response) => {
                console.log(">>" + (response) + "<<");
                if (response !== '') {
                    console.log("Aggiornamento dati ICRON")
                    if (response !== undefined && response.partecipanti != undefined) {
                        this.caricaPartecipanti(response);
                        this.loadFlussoMessaggi();
                    }
                }
            }); //fine
        },

        getNumMancanti( codCP ){
            const val = this.numRilevati - this.numeroTotaleRitirati - this.mappaIntermedi[codCP];
            if (val < 0 ) return 0;
            return val;
        },
        
        inviaWA(){
            let jsonData = 
                {
                    "partecipante": {
                        "note": "{\"object\":\"whatsapp_business_account\",\"entry\":[{\"id\":\"108009718735156\",\"changes\":[{\"value\":{\"messaging_product\":\"whatsapp\",\"metadata\":{\"display_phone_number\":\"393792397100\",\"phone_number_id\":\"107863272184278\"},\"contacts\":[{\"profile\":{\"name\":\"Lorenzo Brunello\"},\"wa_id\":\"393355817982\"}],\"messages\":[{\"from\":\"393355817982\",\"id\":\"wamid.HBgMMzkzMzU1ODE3OTgyFQIAEhgUM0FEOUNEQTFFQzgwOTAwMzREMEQA\",\"timestamp\":\"1676209097\",\"type\":\"image\",\"image\":{\"mime_type\":\"image\/jpeg\",\"sha256\":\"Ytgmy8bhpxXMJ3fcdqJoahcfRJsPI48rgl+uTXXo1xE=\",\"id\":\"1118043928868143\"}}]},\"field\":\"messages\"}]}]}",
                        "telefono": this.currentItem.telefono,
                        "data": this.messaggioSelected
                    }
                    
                }

            this.invioWAServer(this.urlInviaMessaggioWA, jsonData ).then((response) => {
                console.log(">>" + (response) + "<<");
                if (response !== '') {
                   this.inviaMessaggio = false;
                }
             }); //fine
        },


        getLabel(str) {
            if (str == 'image') return "Foto";
            else if (str == 'text') return "Messaggio";
            else if (str == 'location') return "Posizione";
            else if (str == 'interactive') return "Bottone";

        },

        getNota(nota) {
            try {
                if (nota !== undefined) {
                    if (nota.indexOf("Conferma registrazione") != -1 || nota.indexOf( "Registration confirm") != -1 ) {
                        return "Conferma registrazione";
                    }

                    if (nota.startsWith("{")) {
                        //console.log(nota)
                        const msg = JSON.parse(nota);
                        if (msg['text'] != undefined && msg['text']['body'] != undefined) {
                            return msg['text']['body'];
                        }
                        if (msg['template'] != undefined && (nota.indexOf("aiuto") != -1 || nota.indexOf("help") != -1 ) ) {
                            return "Richiesta di aiuto";
                        }


                    }
                }
            } catch (error) {

            }

            return nota;
        },

        getDetailMessages() {
            return this.detailMessages;
        },

        configRace(response) {
            this.configEvento = response.evento;

            if (response == undefined || response.evento == undefined) {
                this.refreshAll();
                return;
            }
            this.configEvento['style_numCP'] = 'Num. CP,text-align: center; color: white; background-color:#B71C1C';
            this.configEvento['style_lastCP'] = 'Ultimo CP,text-align: left; color: #B71C1C; background-color:lightgrey; font-weight: bold;';
            this.configEvento['style_atleta'] = 'Atleta,text-align: left; font-weight: bold;';
            this.configEvento.idGaraAri = response.idGaraAri;

            this.checkpoints = response.checkpoints

            this.linkPdfDocumentiViaggio = response.linkPdfDocumentiViaggio

            if (this.local !== undefined) {
                const toks = this.local.split(",");
                toks.forEach(tok => {
                    if (tok.indexOf("=") !== -1) {
                        const keyval = tok.split("=");
                        this.configEvento[keyval[0]] = this.normalize(keyval[1]);
                    }
                })
            }

            this.rankTitle = this.configEvento['nome'].replaceAll("&", "e");

            this.color = this.configEvento.color !== undefined ? this.configEvento.color : 'blue darken-4';
            this.baseStyle = this.configEvento.baseStyle !== undefined ? this.configEvento.baseStyle : this.baseStyle;
            this.showButtons = true;
            this.showPrint = (this.configEvento.showPrint !== undefined && this.configEvento.showPrint == 'true') ? true : false;
            this.showDownload = (this.configEvento.showDownload !== undefined && this.configEvento.showDownload == 'true') ? true : false;

            this.orderByField = (this.configEvento.orderByField !== undefined) ? this.configEvento.orderByField : null
            this.direction = (this.configEvento.orderByDirection !== undefined) ? (this.configEvento.orderByDirection == 'ASC' ? true : false) : false

            this.fields = ['dorsale:ID', 'naz', 'atleta', 'stato', 'selfie', 'telefono', 'lastCP:Ultimo CP', 'numCP'];
            if (this.checkpoints !== undefined) {
                this.checkpoints.forEach(cp => {
                    this.fields.push('CK' + cp.idAri + ":" + cp.nome);
                    this.mappaIntermedi['CK' + cp.idAri] = 0;
                });
            }

            this.detailFields = ['stato', 'selfie' , 'telefono', 'email', '', 'numCP', 'lastCP:Ultimo CP', ''];
            if (this.checkpoints !== undefined) {
                this.checkpoints.forEach(cp => {
                    this.detailFields.push('CK' + cp.idAri + ":" + cp.nome);
                });
            }

            this.initFields();

            //this.caricaPartecipanti(response);


            
            //this.loadFlussoMessaggi();
            
            //setTimeout(this.loadFlussoMessaggi, 2000);
            
            setTimeout(this.loadAggiornamentoDati, 1000);
            
            // this.myInterval = setInterval(this.loadFlussoMessaggi, 60000 );
            this.myInterval2 = setInterval(this.loadAggiornamentoDati, 180000);
            
            this.configOK = true;
        },


        caricaPartecipanti(response) {

            if (this.checkpoints !== undefined) {
                this.checkpoints.forEach(cp => {
                    this.mappaIntermedi['CK' + cp.idAri] = 0;
                });
            }


            this.items = [];
            this.elencoClassifica = [];



            this.numRilevati = 0;

            for (var i = 0; i < response.partecipanti.length; i++) {
                var rigaClassifica = response.partecipanti[i];

                if (rigaClassifica["nazione"] == null || rigaClassifica["nazione"] == "") {
                    rigaClassifica["naz"] = "it";
                } else {
                    rigaClassifica["naz"] = rigaClassifica["naz"];
                }

                rigaClassifica["atleta"] = rigaClassifica["cognome"] + " " + rigaClassifica["nome"];



                rigaClassifica['numCP'] = 0;
                rigaClassifica['lastCP'] = "-";

                if (rigaClassifica.stato == 'DISTANZA INFERIORE') rigaClassifica.stato = "NON COMPLETATO"

                if (rigaClassifica.stato == 'ASSENTE') rigaClassifica.stato = "NON PARTITO"
                if (rigaClassifica.stato == 'BREVETTATO') rigaClassifica.stato = "COMPLETATO"
                if (rigaClassifica.stato == 'NON BREVETTATO') rigaClassifica.stato = "NON COMPLETATO"


                if (rigaClassifica.checkpoints !== undefined) {
                    let map1 = {};
                    let cpValidi = [];

                    rigaClassifica.checkpoints.forEach(cp => {
                        if (map1[cp.id] == undefined) {
                            //console.log('CK'+cp.id)
                            cpValidi.push(cp);
                            map1[cp.id] = cp.id;
                            this.mappaIntermedi['CK' + cp.id] = this.mappaIntermedi['CK' + cp.id] + 1;
                           // console.log(i + "___" +cp.id+ "____" +this.mappaIntermedi['CK' + cp.id]+ "  :  " + rigaClassifica['atleta'])
                           // console.log(i + "___" +cp.id+ "____" +this.mappaIntermedi['CK' + cp.id]+ "  :  " + rigaClassifica['atleta'] + "  " + cp.orarioPassaggio )

                        }
                    })

                    rigaClassifica.checkpoints = cpValidi;


                    rigaClassifica.checkpoints.forEach(cp => {

                        //console.log('CK'+cp.id)
                        rigaClassifica['CK' + cp.id] = cp.orarioPassaggio;
                        rigaClassifica['numCP'] = rigaClassifica['numCP'] + 1;
                        rigaClassifica['lastCP'] = cp.nome;
                        rigaClassifica['lastIdCP'] = cp.id;

                        rigaClassifica['lastCPTime'] = cp.orarioPassaggio;

                    })



                    if (rigaClassifica.checkpoints.length > 0 && rigaClassifica.checkpoints.length < this.checkpoints.length && rigaClassifica.stato == 'COMPLETATO') {
                        rigaClassifica.stato = "NON COMPLETATO";
                    }

                   
                    


                    if (rigaClassifica.note == undefined) rigaClassifica.note = ""


                }

                if (rigaClassifica['numCP'] > 0)
                    this.numRilevati++;
                else {
                    rigaClassifica['lastCP'] = "";
                    rigaClassifica['lastCPTime'] = "Non partito";
                    rigaClassifica['lastIdCP'] = "ND";
                }



                this.elencoClassifica.push(rigaClassifica)

            }

            this.numeroTotaleIscritti = this.elencoClassifica.length;

            this.numeroTotaleRitirati = this.elencoClassifica.filter(p => {
                return p.stato == 'RITIRATO';
            }).length;

            this.numeroTotaleCompletati = this.elencoClassifica.filter(p => {
                return p.stato == 'COMPLETATO' ;
            }).length;

            this.numeroTotaleArrivati = 0;
            if (this.checkpoints.length > 0) {
                this.numeroTotaleArrivati = this.mappaIntermedi['CK' + this.checkpoints.at(-1).idAri];
            }




            this.numeroTotaleAttivi = this.elencoClassifica.filter(p => {
                return p.stato == 'NON COMPLETATO' || p.stato == 'DISTANZA INFERIORE';
            }).length;

            this.numeroTotaleAttivi = this.numRilevati - this.numeroTotaleArrivati - this.numeroTotaleRitirati; 

            this.elencoClassifica.forEach(elem => {
                if (elem.nazione && elem.nazione.length > 2) {
                    elem.nazione = elem.nazione.substring(0, 2).toLowerCase();
                } else if (elem.nazione === undefined || elem.nazione === '') {
                    elem.nazione = 'it';
                }

                if (elem.pettorale !== undefined) {
                    elem.pett = elem.pettorale
                } else if (elem.p !== undefined) {
                    elem.pett = elem.p
                } else if (elem.dorsale !== undefined) {
                    elem.pett = elem.dorsale
                } else if (elem.dors !== undefined) {
                    elem.pett = elem.dors
                }

            })



            this.showClassifica();
        },

        magicRil(){

            if (!confirm("Confermi la correzione automatica delle foto non riconosciute ? ")) return;

            const numCP = this.checkpoints.length;
           this.elencoClassifica.forEach(p => {
                if (p.stato == 'NON COMPLETATO') {

                    //vedo se ha l'ultimo
                    if (p.checkpoints.at(-1).id == this.checkpoints[numCP-1].idAri) {

                        let cp = p.checkpoints;
    
                        for (let i = 0; i< numCP; i++) {
                            let cpRace = this.checkpoints[i];
                            let cpRaceCancelloInizio = cpRace.dataIniCancello+" "+cpRace.oraIniCancello;
                            let cpRaceCancelloFine = cpRace.dataFineCancello+" "+cpRace.oraFineCancello;
    
                            let filtroCP = cp.filter( f => {
                                return f.id == cpRace.idAri
                            })
    
                            if (filtroCP.length ==0) {
                                
                                /*if (i > 0 && i < ) {
                                    cpRaceCancelloInizio = this.checkpoints[i-1].dataEvento;
                                    cpRaceCancelloFine = this.checkpoints[i+1].dataEvento;

                                }*/
                                
                                if ( this.conversazioniAttive[p.id] !== undefined) {
                                    let fotoCandidate = this.conversazioniAttive[p.id].filter( conv => {
                                        if (conv.tipoMessaggio == 'image' && (conv.note.startsWith("*Attenzione*") || conv.note.startsWith("*Warning*"))){
                                            
                                            if ( conv.dataEvento >= cpRaceCancelloInizio && conv.dataEvento <= cpRaceCancelloFine && conv.dataEvento < p.checkpoints.at(-1).orarioPassaggio ) {
                                                //console.log("Conv attiva nel cancello")
                                                return true;
                                            }
                                        }
                                    })
    
                                    if (fotoCandidate.length > 0 ) {
                                        
                                        let dataRil = moment( fotoCandidate.at(-1).dataEvento, "YYYY-MM-DD HH:mm:ss");
                                        dataRil = moment(dataRil.toDate()).format("D/M/YYYY HH:mm:ss");
    
                                        console.log("Non trovato cp " +  cpRace.idAri + " a " + p.cognome+" "+p.nome);
                                        //console.log(this.conversazioniAttive[p.id])
    
    
                                        console.log("salvaRilevamentoSmart " + cpRace.codiceAPP+" -- " + dataRil)
                                        this.salvaRilevamentoSmart(p, cpRace, dataRil)
    
                                    } else {
                                        if (i == 0) { // ho perso la partenza
                                            let dataRil = moment( cpRaceCancelloInizio, "YYYY-MM-DD HH:mm:ss");
                                            dataRil = moment(dataRil.toDate()).format("D/M/YYYY HH:mm:ss");
        
                                            console.log("Non trovato cp " +  cpRace.idAri + " a " + p.cognome+" "+p.nome);
                                            //console.log(this.conversazioniAttive[p.id])
        
        
                                            console.log("salvaRilevamentoSmart " + cpRace.codiceAPP+" -- " + dataRil)
                                            this.salvaRilevamentoSmart(p, cpRace, dataRil)
                                        }
                                    }

                                }




                            }
    
    
                        }
                    } else {
                        console.log("Non arrivato  " +  p.cognome + " "+ p.nome);
                    }
                    

                }
           });

           this.raceInfo = false;
            
        },

        refreshAll() {
            if (this.flussomessaggi) {
                this.loadFlussoMessaggi();
            }else {
                clearInterval(this.myInterval);
                clearInterval(this.myInterval2);
                window.location.reload();

            }

        },

        openLink(url) {
            window.open(url, "_blank");
        },

        openWA(n) {
            let _url = 'https://api.whatsapp.com/send/?phone=%2B' + n.telefono + '&text=Ciao ' + n.nome + ' ' + n.cognome + ',%0a%0asono l\'organizzatore della manifestazione%0a%0a&type=phone_number&app_absent=0'
            window.open(_url, "_blank");
        },

        randoLive() {
            let url = "https://www.icron.it/live/random/" + this.configEvento.idGaraAri + "/" + this.$route.query.token;
            window.open(url, "_blank");
        },

        cpOperatore() {
            let url = "https://www.icron.it/live/aricp?source=ARI&circuito=ARI%3ACLASSIC&idEvento="+this.configEvento.idGaraAri+"&token="+this.$route.query.token;
            window.open(url, "_blank");
        },

        filterState(tipoFiltro) {
            if (tipoFiltro == 'iscritti') {
                this.itemsF = this.items;
            } else if (tipoFiltro == 'partiti') {
                this.itemsF = this.items.filter(p => {
                    return p.stato == "DISTANZA INFERIORE" || p.stato == 'NON COMPLETATO' || p.stato == 'RITIRATO' || p.stato == 'COMPLETATO'
                })
            } else if (tipoFiltro == 'ritirati') {
                this.itemsF = this.items.filter(p => {
                    return p.stato == "RITIRATO"
                })
            } else if (tipoFiltro == 'attivi') {
                this.itemsF = this.items.filter(p => {
                    return p.stato == 'NON COMPLETATO' || p.stato == 'DISTANZA INFERIORE'
                })
            } else if (tipoFiltro == 'completati') {
                this.itemsF = this.items.filter(p => {
                    return p.stato == "COMPLETATO"
                })
            }
        },

        openTelegram(codiceApp) {
            let botPrefix = "";
            if (this.botId == 2) botPrefix = "2";
            let url = "https://t.me/RandoManager" + botPrefix + "Bot?start=" + codiceApp.replaceAll("#", "-");
            console.log(url)
            alert(url);
            //navigator.clipboard.writeText(url);
            // window.open(url, "_new");
        },

        openImage(url) {
            window.open('https://www.icron.it/' + url);
        },

        stampaQRCode(item) {
            if (item.latitudine == '-1.0' || item.longitudine == '-1.0') {
                alert ("Attenzione non puoi stampare i QR Code se non inserisci le coordinate GPS in ARI. Dopo aver inserito in ARI aggiornare la console e riprovare")
            } else {
                window.open(item.linkCodice, item.codiceAPP);
            }
        },

        getTelegramLink(codiceApp) {
            let botPrefix = "";
            if (this.botId == 2) botPrefix = "2";
            let url = "https://t.me/RandoManager" + botPrefix + "Bot?start=" + codiceApp.replaceAll("#", "-");
            return url
        },

        openCartediViaggio() {
            this.openLink(this.linkPdfDocumentiViaggio);
        },

        getLink(value, key, pett) {
            if (!key.columnName.startsWith("CK")) return undefined;
            if (value == undefined || value == '') return undefined;

            const cp = this.checkpoints.find(elem => {
                let toFind = 'CK' + elem.idAri;

                return key.columnName == toFind
            })

            if (cp !== undefined) {
                const cApp = cp.codiceAPP.toLowerCase().replaceAll("#", "%23");
                let link = "https://www.icron.it/apps/telegram/" + cApp + "/qr/";
                console.log(value);
                let filename = value.replaceAll(":", "").replaceAll("-", "").replaceAll(" ", "").replaceAll(".", "");
                filename += "_" + this.configEvento.idGaraIcron + "_" + pett;
                filename += ".jpg";
                return link + filename
            }

            return undefined

        },

        getClass(param) {
            if (param == 'COMPLETATO') return 'green darken-4 white--text no-wrap'
            else if (param == 'RITIRATO') return 'red darken-4 white--text no-wrap'
            else if (param == 'NON COMPLETATO') return 'yellow black--text no-wrap'
            else if (param == 'NO') return 'orange black--text text-xs-center'
            else if (param == 'SI') return 'white black--text text-xs-center'

            return 'no-wrap'
        },

        getField(item, key) {
            return item[this.getFieldName(key)];
        },

        getFieldValue(item, field) {
            if (field.columnName.indexOf("+") !== -1) {
                const cc = field.columnName.split("+");
                let campoComposto = "";
                cc.forEach(ele => {
                    campoComposto += item[ele] + " ";
                })
                return campoComposto;
            }

            return this.riduci(item[field.columnName])
        },


        ritiro() {
            if (confirm("Confermi il ritiro dell'atleta " + this.currentItem.cognome + " " + this.currentItem.nome + " ? ")) {

                let cpLast = this.checkpoints.filter( cp => {
                    return this.currentItem.checkpoints.at(-1).id == cp.idAri
                })

                if (cpLast.length > 0) {
                    let postData  = {
                        "rilevamento": {
                            "pettorale": this.currentItem.pett,
                            "stato": -1,
                            "checkpoint": cpLast[0].codiceAPP
                        }
                    }
                    console.log(postData);
                    this.registraRitiroARI(this.urlRegistraRitiro, postData).then((rowData) => {
                        if (rowData.esito == 'OK') {
                           
                            this.dettaglio = false;
                            this.refreshAll();
                        }
                    });
                } else {
                    alert("Impossibile trovare CP di ritiro")
                }


            }
        },



        addRilev(field) {
            this.valueSelected = '';

            console.log(field);
            let cps = this.checkpoints.filter(_cp => {
                return field.columnName == 'CK' + _cp.idAri;
            })
            if (cps.length > 0) {
                this.currentCP = cps[0];
                this.aggiungiTempo = true;
            } else {
                alert("Errore recupero CP")
            }
        },

        validaFoto(item) {
            console.log(item);
            this.selectedTime = item.dataEvento;
            this.validaTempo = true;
            this.selectedConversation = item;
        },

        salvaSelfie() {

            let media = this.selectedConversation.data.replaceAll("/whatsapp/", "").replaceAll(".jpg", "");

            let postData = { codiceCheckpoint: "SELFIE", token: this.selectedConversation.idregistrazione + "_" + media };

            this.salvaRilevamentoARI(this.urlSalvaRilevamento, postData).then((rowData) => {
                if (rowData.esito == 'OK') {
                    this.loadFlussoMessaggi()
                    this.validaTempo = false;
                } else {
                    alert("Errore:" + rowData.messaggio);
                }
            });

        },

        salvaTempo() {
            let media = this.selectedConversation.data.replaceAll("/whatsapp/", "").replaceAll(".jpg", "");

            let postData = { codiceCheckpoint: this.checkpointSelected.codiceAPP, token: this.selectedConversation.idregistrazione + "_" + media };

            this.salvaRilevamentoARI(this.urlSalvaRilevamento, postData).then((rowData) => {
                if (rowData.esito == 'OK') {
                    this.loadFlussoMessaggi()
                    this.validaTempo = false;
                } else {
                    alert("Errore:" + rowData.messaggio);
                }
            });
        },



        salvaRil() {
            //alert(this.valueSelected)

            let input = {};
            let dataRil = moment(this.valueSelected, "YYYY-MM-DD HH:mm");
            if (!dataRil.isValid()) {
                alert("Data non valida: " + this.valueSelected + "\nUsare il formato  ANNO-MM-DD HH:mm");
                return;
            }

            let data1 = moment(dataRil.toDate()).format("YYYYMMDDHHmm");
            let data2 = moment(new Date()).format("YYYYMMDDHHmm");

            if (data1 > data2) {
                alert("Data futura non valida: " + this.valueSelected);
                return;
            }

            input.timestamp = moment(dataRil.toDate()).format("D/M/YYYY HH:mm:ss");
            input.idgara = this.configEvento.idGaraIcron
            input.checkpoint = this.configEvento.idGaraIcron + "_" + this.currentCP.codiceAPP + "_START"
            console.log(input);

            this.salvaRilevamento(
                this.currentItem,
                input
            ).then((rowData) => {
                if (rowData.result == 'success') {
                    //alert(rowData.result + "\nEseguire l'aggiornamento della pagina ...");
                    //this.forceReload();
                    this.loadAggiornamentoDati();
                    this.annullaRil();
                    this.validaTempo = false
                }
            });

        },

        annullaRil() {
            this.valueSelected = '';
            this.aggiungiTempo = false;
        },

        salvaRilevamento(item, params) {
            let row = item;
            var body = {};
            console.log(item);
            console.log("parametri>" + JSON.stringify(params));


            let postData = { checkpoint: params.checkpoint, id: row.id, pettorale: row.id, idgara: params.idgara, timestamp: params.timestamp, latitudine: "-2", longitudine: "-2", type: "admin_cp" };
            // postData = {"checkpoint":params.idGara+"_CK1172#E9E_START","latitudine":"-2","idgara":"20222039","id":"1650709063770","type":"admin_cp","longitudine":"-2","pettorale":row.id,"timestamp":"20/6/2022 00:00:00"}
            let url1 = "https://www.icron.it/apps/ari/salvaRilevamentiApp.php"


            console.log(postData);
            return fetch(url1, {
                method: 'post',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(postData)
            })
                .then(function (response) {
                    return response.json();
                })
        },



        salvaRilevamentoSmart(item, cpRace, ts) {
         
            let postData = {
                "checkpoint": cpRace.idGara+"_"+cpRace.codiceAPP+"_START",
                "id": item.id,
                "pettorale": item.id,
                "idgara": cpRace.idGara,
                "timestamp": ts,
                "latitudine": "-4",
                "longitudine": "-4",
                "type": "admin_cp"
            }


          //  let postData = { checkpoint: params.checkpoint, id: row.id, pettorale: row.id, idgara: params.idgara, timestamp: params.timestamp, latitudine: "-2", longitudine: "-2", type: "admin_cp" };
            // postData = {"checkpoint":params.idGara+"_CK1172#E9E_START","latitudine":"-2","idgara":"20222039","id":"1650709063770","type":"admin_cp","longitudine":"-2","pettorale":row.id,"timestamp":"20/6/2022 00:00:00"}
            let url1 = "https://www.icron.it/apps/ari/salvaRilevamentiApp.php"


            console.log(postData);

            //return null;
            return fetch(url1, {
                method: 'post',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(postData)
            })
                .then(function (response) {
                    return response.json();
                })
        },



        getValoreMobile(item, key) {
            //console.log(key)
            const newKey = this.configEvento[key];
            if (newKey !== undefined && newKey.startsWith("'")) return newKey.replaceAll("'", "");
            return item[newKey];
        },

        getColumnName(field) {
            return field.columnName
        },

        getFieldName(key) {
            if (key.indexOf(":") !== -1) {
                return key.split(":")[0];
            }
            return key;
        },

        getFieldlabel(key) {
            if (key.indexOf(":") !== -1) {
                return key.split(":")[1];
            }
            return key;
        },

        getColor(numCP) {
            if (numCP == 0) return "";
            else if (numCP < this.checkpoints.length) {
                return "orange darken-1 white--text";
            } else {
                return "green darken-4 white--text";
            }
        },

        openDettaglio(idIscrizione) {
            let items = this.itemsF.filter(p => {
                return p.id == idIscrizione
            });

            this.setCurrentItem(items[0]);
        },

        setCurrentItem(item, colDef) {
            this.currentItem = item;
            this.messaggi = false;
            this.detailMessages = [];
            this.dettaglio = true;
        },

        orderBy(field) {
            if (this.orderByField === field.columnName) {
                this.direction = !this.direction;
            } else {
                this.direction = true;
                this.orderByField = field.columnName;
            }
            this.itemsF = this.filteredList();
        },

        changedLabel(event) {
            console.log('Changed:' + event);
            this.categoriaSelected = event;

            this.itemsF = this.filteredList();
        },
        changedCP(event) {
            console.log('Changed:' + JSON.stringify(event));
            this.cpSelected = event;

            this.itemsF = this.filteredList();
        },

        changedDivisione(event) {
            this.divisioneSelected = event;
            this.itemsF = this.filteredList();
        },

        changedSearch(event) {
            console.log('Changed:' + event);
            this.searchText = event;

            if (this.flussomessaggi) {
                this.detailFlowMessagesF = this.filterMessages();
            } else {
                this.itemsF = this.filteredList();
            }

        },

        changedView(event) {
            console.log('Changed:' + event);
            this.viewSelected = event;
            this.itemsF = this.filteredList();
            this.filtroDialog = false;
        },

        annullaFiltro() {
            this.viewSelected = "TUTTI";
            this.cpSelected = undefined;
            this.filtroDialog = false;
            this.itemsF = this.filteredList();
        },

        removeUndefined(value) {
            if (value == undefined) return "";
            return value;
        },

        showClassifica() {
            this.items = this.elencoClassifica;
            this.itemsF = this.filteredList();
        },

        gotoHome() {
            // this.$router.push('/classifiche');
        },

        gotoAdmin() {
            this.$router.push('/admin');
        },

        showResponse(message) {
            alert(message);
        },

        compareField(a, b, fieldName = null) {

            if (fieldName == null) fieldName = this.orderByField;
            if (fieldName == 'atleta') fieldName = 'cognome';

            const molti = this.direction ? 1 : -1;

            let valoreA = a[fieldName];
            let valoreB = b[fieldName];

            if (valoreA === undefined && valoreB == undefined) return 0;
            else if (valoreA === undefined) {
                return -1 * molti;
            } else if (valoreB === undefined) {
                return 1 * molti;
            }

            if (!isNaN(valoreA) && !isNaN(valoreB)) {
                valoreA = parseFloat(valoreA);
                valoreB = parseFloat(valoreB);
            }

            if (valoreA < valoreB) {
                return -1 * molti;;
            }
            if (valoreA > valoreB) {
                return 1 * molti;;
            }
            return 0;
        },

        simpleCompare(a, b) {
            return this.compareField(a, b)
        },

        getClasseFiltro() {
            if (this.cpSelected !== undefined) {
                return "red--text"
            }
            return ''
        },

        filteredList() {
            var listaSearch = this.items;
            if (this.searchText !== '' && this.searchText != null) {
                listaSearch = this.items.filter((p) => {
                    let res =
                        p != null &&
                        p.atleta != null &&
                        p.atleta.toUpperCase().indexOf(
                            this.searchText.toUpperCase()
                        ) !== -1;
                    let res1 =
                        p != null &&
                        p.squadra != null &&
                        p.squadra.toUpperCase().indexOf(
                            this.searchText.toUpperCase()
                        ) !== -1;

                    let res2 =
                        p != null &&
                        p.pett != null &&
                        p.pett == this.searchText;

                    let resTot = res || res1 || res2;
                    return resTot;
                });
            }

            if (this.viewSelected !== 'TUTTI') {
                listaSearch = listaSearch.filter((p) => {
                    return p['numCP'] > 0
                });
            }

            if (this.cpSelected !== undefined) {
                listaSearch = listaSearch.filter((p) => {
                    return (this.cpSelected.idAri == p['lastIdCP'])
                });
            }

            if (this.orderByField !== null) {
                console.log("Order by:" + this.orderByField)
                listaSearch.sort(this.simpleCompare);
            }

            if (this.configEvento.filtroRighe) listaSearch = listaSearch.slice(0, parseInt(this.configEvento.filtroRighe));

            return listaSearch;
        },


        filterMessages() {
            let listaSearch = this.detailFlowMessages;
            if (this.searchText !== '' && this.searchText != null) {
                listaSearch = this.detailFlowMessages.filter((p) => {
                    console.log(p);
                    let res =
                        p != null &&
                        p.cognome != null &&
                        p.cognome.toUpperCase().indexOf(
                            this.searchText.toUpperCase()
                        ) !== -1;
                    let res1 =
                        p != null &&
                        p.note != null &&
                        this.getNota(p.note) != null &&
                        this.getNota(p.note).toUpperCase().indexOf(
                            this.searchText.toUpperCase()
                        ) !== -1;

                    let res2 =
                        p != null &&
                        p.jsonData != null &&
                        p.jsonData.toUpperCase().indexOf(
                            this.searchText.toUpperCase()
                        ) !== -1;

                    let res3 =
                        p != null &&
                        p.nome != null &&
                        p.nome.toUpperCase().indexOf(
                            this.searchText.toUpperCase()
                        ) !== -1;

                    console.log(this.searchText + " = " + res + " | " + res1 + " | " + res2 + " | " + res3)

                    let resTot = res || res1 || res2 || res3;
                    return resTot;
                });
            }

            return listaSearch;
        },

        getFields() {
            return this.listaCampi;
        },

        getDetailFields() {
            return this.listaCampiDettaglio;
        },

        initFields() {
            console.log("initFields")

            if (this.fields.length > 0) {
                let colNum = 0;
                this.fields.forEach(elem => {
                    // console.log(elem)

                    let label = this.getFieldlabel(elem);
                    let name = this.getFieldName(elem);
                    let style = this.baseStyle;

                    const fieldStyle = this.configEvento['style_' + name];
                    if (fieldStyle !== undefined) {
                        let _st = fieldStyle.split(",");
                        if (_st.length > 0)
                            label = _st[0];
                        if (_st.length > 1)
                            style = _st[1];
                    }

                    const _obj = {
                        columnName: name,
                        label: label,
                        id: colNum++,
                        style: style
                    };
                    //console.log(_obj)
                    this.listaCampi.push(_obj);
                })
            }
            console.log(this.listaCampi)

            if (this.detailFields.length > 0) {
                let colNum = 0;
                this.detailFields.forEach(elem => {
                    // console.log(elem)

                    let label = this.getFieldlabel(elem);
                    let name = this.getFieldName(elem);
                    let style = this.baseStyle;

                    const fieldStyle = this.configEvento['style_' + name];
                    if (fieldStyle !== undefined) {
                        let _st = fieldStyle.split(",");
                        if (_st.length > 0)
                            label = _st[0];
                        if (_st.length > 1)
                            style = _st[1];
                    }

                    const _obj = {
                        columnName: name,
                        label: label,
                        id: colNum++,
                        style: style
                    };
                    // console.log(_obj)
                    this.listaCampiDettaglio.push(_obj);
                })
            }
            console.log(this.listaCampiDettaglio)
        }

    },
};
</script>

<style scoped>
td {
    height: 10px !important;
    _background-image: linear-gradient(60deg, grey, lightgray);
}

table.v-table tbody td:not(:first-child),
table.v-table tbody th:first-child,
table.v-table tbody th:not(:first-child),
table.v-table thead td:first-child,
table.v-table thead td:not(:first-child),
table.v-table thead th:first-child,
table.v-table thead th:not(:first-child) {
    padding: 0 5px;
}

.frazioniTitle {
    text-align: center;
    background-color: lightgrey;
    border-radius: 0px 0px 3px 3px;
    margin-right: 5px;
}

.frazioniValue {
    text-align: center;
    background-color: white;
    border-radius: 0px 0px 3px 3px;
    border-bottom: 1px solid lightgray;
}

.frazioniValueR {
    text-align: right !important;
    padding-right: 10px !important;
}

.frazioniValueL {
    text-align: left !important;
    padding-left: 10px !important;
}

.frazioniTitleFinale {
    text-align: center;
    color: white;
    font-style: italic;
    _border: 1px solid lightgray;
    _border-radius: 0px 0px 7px 7px;
    _font-weight: bold;
}

.frazioniTitleFinaleDesk {
    text-align: center;
    color: white;
    font-style: italic;
    _border-radius: 0px 5px 5px 0px;
}

.frazioniTitleRow {
    text-align: center;
    background-color: lightgrey;
    _border-radius: 0px 0px 7px 7px;
}

.frazioniTitleRowDesk {
    text-align: center;
    background-color: lightgrey;
    _border-radius: 5px 0px 0px 5px;
}

.frazioniValueRow {
    text-align: center;
    background-color: rgb(243, 243, 243);
    _border-radius: 0px 0px 7px 7px;
}

.passaggio {
    background-color: lightgrey;
    text-align: center;
    color: green;
    font-style: italic;
    _border: 1px solid lightgray;
    border-radius: 5px 5px 5px 5px;
    _font-weight: bold;
}

.laps {
    text-align: center;
    color: white;
    font-style: italic;
}

.clock {
    background-color: #212121;
    text-align: center;
    color: white;
    font-style: italic;
}

.cardUp {
    background-color: lightgray;
    color: #0D3D58;
    _border: 1px solid lightgray;
    border-radius: 10px 10px 0px 0px;
}

.cardBottom {
    background-color: lightgray;
    color: #0D3D58;
    _background-color: lightgray;
    _color: #0D3D58;
    _border: 1px solid lightgray;
    border-radius: 0px 0px 10px 10px;
}

.cardStatsHeader {
    background-color: #0d47a1;
    color: white;
    border-radius: 5px 5px 0px 0px;
}

.cardStats {
    background-color: white;
    color: black;
    border: 2px solid lightgray;
    border-radius: 5px 5px 5px 5px;
}

a {
    color: white;
}

/* unvisited link */
a:link {
    color: white;
}

/* visited link */
a:visited {
    color: white;
}

/* mouse over link */
a:hover {
    color: white;
}

/* selected link */
a:active {
    color: white;
}
</style>
